import { createSlice } from '@reduxjs/toolkit';

// Initial state for file upload
const initialState = {
  isUploading: false,
  progress: 0,
  uploadedFiles: [],
  error: null
};

// Create slice
const fileUploadSlice = createSlice({
  name: 'fileUpload',
  initialState,
  reducers: {
    fileUploadStart: (state) => {
      state.isUploading = true;
      state.progress = 0;
      state.error = null;
    },
    fileUploadSuccess: (state, action) => {
      state.isUploading = false;
      state.uploadedFiles = action.payload;
      state.progress = 100;
      state.error = null;
    },
    fileUploadFailure: (state, action) => {
      state.isUploading = false;
      state.error = action.payload;
      state.progress = 0;
    },
    fileUploadProgress: (state, action) => {
      state.progress = action.payload;
    }
  }
});

// Export actions and reducer
export const { 
  fileUploadStart, 
  fileUploadSuccess, 
  fileUploadFailure, 
  fileUploadProgress 
} = fileUploadSlice.actions;

export default fileUploadSlice.reducer;